import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import StatsDisplay from '../components/StatsDisplay';
import SeasonSelect from '../components/SeasonSelect';

export default function MainLayout() {
  return (
    <div className="flex min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-300 overflow-x-hidden">
      <Sidebar />
      <StatsDisplay />
      <main className="flex-1 min-w-0 ml-0 md:ml-64 p-4 md:p-8 pt-20 md:pt-8 relative">
        {/* Sezon seçici her sayfanın üstünde: seçim Teklifler, Takvim, Raporlar ve Gösterge Paneli'ni süzer */}
        <div className="flex justify-end mb-4">
          <SeasonSelect />
        </div>
        <Outlet />
      </main>
    </div>
  );
}